export default {
  head: {
    title: 'Account Transfers operations billing',
    action: {
      create: {
        tooltip: 'Create new Account Transfers report'
      },
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Account Transfers billing operation'
    },
    details: {
      title: 'Account Transfers operation details'
    }
  }
};
